export default {
    _prefix: "FormEditorSidePanel.AiScoring",
    labels: {
        heading: "AI Scoring",
        assistanceIcon: "AI Scoring",
        questions: "questions",
        question: "question",
        condition: "condition",
        conditions: "conditions",
        aiScoringMaxQuestionsExceeded: (maxAIScoringQuestions: {
            maxAIScoringQuestions: number;
        }) =>
            "An evaluation form can have a maximum of {{maxAIScoringQuestions}} questions configured with AI Scoring.",
    },
    summary: (data: {
        questionsConfiguredWithAiScoring: number;
        totalQuestionCount: number;
        entity: string;
        maxPermissibleQuestionsWithAiScoring: number;
    }) => {
        return "{{questionsConfiguredWithAiScoring}} of {{totalQuestionCount}} {{entity}} configured (Max. {{maxPermissibleQuestionsWithAiScoring}})";
    },
};
